import http, { endpoints } from "../http"
import {
  groupTextsFromDto,
  initializeTextGroups,
  mapTextFromDto,
} from "./helpers"
import { IGetTextHistoryParams, ISaveTextParams } from "./models"
import { ICaseTextDto } from "./dtos"
import { IDatahubCase } from "../cases/models"
import { ICommonResponse } from "../types"
import { LocalizedError } from "localization"

const datahubClient = http.createClient(`${endpoints.datahub}`)

export default class TextsApi {
  static async getCaseTexts(caseId: IDatahubCase["id"]) {
    const response = await datahubClient.get<{
      textSections: ICaseTextDto[]
    }>(`/cases/${caseId}/texts/current`)

    return response?.data?.textSections
      ? groupTextsFromDto(response.data.textSections)
      : []
  }

  static async getTextGroups() {
    const response = await datahubClient.get<{ name: string; title: string }[]>(
      "/Texts/GetAllTextSections"
    )
    return response?.data ? initializeTextGroups(response.data) : []
  }

  static async saveCaseText(params: ISaveTextParams) {
    const response = await datahubClient.post<ICommonResponse>(
      `/cases/${params.caseId}/texts/${params.name}`,
      {
        content: params.content,
      }
    )

    if (!response?.data?.success) {
      throw new LocalizedError("modals.editText.error")
    }

    return response?.data
  }

  static async getTextHistory(params: IGetTextHistoryParams) {
    const response = await datahubClient.get<{
      textSectionsHistory: ICaseTextDto[]
    }>(`/cases/${params.caseId}/texts/${params.name}`)

    return (
      response?.data?.textSectionsHistory
        // remove duplicated content values
        ?.reduce((memo, next) => {
          if (!memo.some(({ content }) => content === next.content)) {
            return memo.concat([next])
          }

          return memo
        }, [] as ICaseTextDto[])
        ?.map(mapTextFromDto) || []
    )
  }
}
